import type { ICorrectionColumnData } from "components/shared/CorrectionTable";
import type { TImportError } from "store/dataImportSlice";

export const formatErrorsEntries = (errors: TImportError[]) => {
    const allEntries = errors.map((error) => error.entry);
    return [...new Set(allEntries)];
};

/**
 * Matches their titles with our keys (based on selectedValues)
 * and saves the original index (column in their file).
 */
export const formatErrorColumns = (elementData: any) => {
    if (!elementData) return [] as unknown as ICorrectionColumnData[];
    const titles: ICorrectionColumnData[] = [];

    Object.keys(elementData).forEach((title, index) => {
        titles.push({ key: title, title, originalIndex: index });
    });

    return titles;
};
